import React, { useMemo, useState, Fragment, useEffect } from 'react';
import {
    MasterDetailForm,
    Widget,
    FormInput,
    Icon,
    FormTextArea,
    InlineEditTable,
    InlineEditColumnProps,
    FormNumber,
    FormSelect,
} from '@digital/ui';
import { Collapse, Table, Tooltip } from 'antd';
import * as Yup from 'yup';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { hasPermission } from '../../../../helpers/permissions';
import { updateTabelaAditivo, updateTabelaContrato, AditivoTotvsContrato, TabelaAditivo, getAllContratoTotvsByContatoId } from '../../../../api/aditivoTotvs';
import { getAllPlanilhaQuantidadeMultiplosGestoresByContrato } from '@app/api/contrato/planilhaQuantidadeContrato';

interface ContratoTotvsProps {
    atualizarTela: () => any;
    contratoSelecinado: any;
    isMultiplosGestores: boolean;
}


const BmTotvs = (props: ContratoTotvsProps) => {
    const { contratoSelecinado, isMultiplosGestores } = props;
    const { Panel } = Collapse;

    const [itemValorAnteriorFormatado, setItemValorAnteriorFormatado] = useState<string>();
    const [atualizarTabela, setAtualizarTabela] = useState<boolean>(false);
    const [pqOptions, setPqOptions] = useState<{
        text: string,
        value: string
    }[]>();
    const [aditivoTotvs, setAditivoTotvs] = useState<AditivoTotvsContrato[]>([]);
    const formatReal = (valor: string) => {
        let tmp = valor + '';
        tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
        tmp = tmp.replace('.,', ',');
        if (tmp.length > 6) {
            tmp = tmp.replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
        }
        return tmp;
    };

    const getAllAditivoTotvs = useMemo(() => {
        if (contratoSelecinado) {
            return getAllContratoTotvsByContatoId(contratoSelecinado).then((data) => {
                if (data) {
                    setAditivoTotvs(data);
                }
            });
        }
    }, [contratoSelecinado, atualizarTabela]);

    useEffect(() => {
        if (isMultiplosGestores)
            getAllPlanilhaQuantidadeMultiplosGestoresByContrato(contratoSelecinado).then((data: any) => {
                if (data) {
                    setPqOptions(data.map((item: any) => {
                        return {
                            text: `PQ ${item.identificador}`,
                            value: item.id
                        }
                    }))
                }
            })
    }, [contratoSelecinado])

    const colum = () => {
        let columns: InlineEditColumnProps<TabelaAditivo>[] = [
            {
                title: 'Item',
                dataIndex: 'item',
                key: 'item',
                width: '1%'
            },
            {
                title: 'Descrição',
                dataIndex: 'descricao',
                key: 'descricao',
                width: '50%'
            },
            {
                title: 'Unidade',
                dataIndex: 'unidade',
                key: 'unidade',
                width: '1%'
            },

        ];

        if (isMultiplosGestores) {
            columns.push({
                title: 'PQ',
                dataIndex: 'pqId',
                key: 'pqId',
                width: '15%',
                render: (text, record, index) => {
                    const obj = pqOptions && pqOptions.find(item => item.value === record.pqId);
                    const texto = obj ? obj.text : 'A Definir';
                    return <> {texto} </>;
                },
                renderEdit: (text, record, index) => {
                    return <FormSelect
                        name={`pqId`}
                        options={pqOptions}
                        defaultValue={record.pqId}
                        disabled={!hasPermission(['SGC_EDITAR_ITENS_BMTOTVS'])}
                    />
                }
            })
        }

        columns.push(
            {
                title: 'Valor Total',
                dataIndex: 'valorTotal',
                key: 'valorTotal',
                width: '15%'
            },
            {
                title: 'Acumulado',
                dataIndex: 'itemValorAnterior',
                key: 'itemValorAnterior',
                width: '15%',
                renderEdit: (text, record, index) => (
                    <>
                        <FormNumber
                            name="itemValorAnterior"
                            formatter={(value: any) => {
                                setItemValorAnteriorFormatado(formatReal(value));
                                return formatReal(value);
                            }} parser={value => value.replace(/[\D]+/g, '')}
                            disabled={!hasPermission(['SGC_EDITAR_ITENS_BMTOTVS'])}
                        />
                    </>
                ),
                render: (text, record, index) => {
                    return <> {record.itemValorAnteriorFormatado}</>;
                }
            },
            {
                title: 'Saldo',
                dataIndex: 'saldoFormatado',
                key: 'saldoFormatado',
                width: '15%',
            })


        return columns;
    }


    return (
        <>
            {hasPermission(['CONTRATO_RESUMO_MEDICOES_VISUALIZAR_ABA']) ? (
                aditivoTotvs.map((bmTotv) => {
                    return (
                        < Collapse bordered={false}
                            expandIcon={() => <Icon type="arrows-right_4" />}>
                            <Panel key={aditivoTotvs[0].id} header={`BM TOTVS - Contrato`} style={{ border: 0 }}>
                                <MasterDetailForm
                                    initialValues={bmTotv}
                                    validationSchema={Yup.object().shape({})}>
                                    <Widget actions={[]}>
                                        <FormInput label="Código Empresa" name="codigoEmpresa" span={2} disabled={true} />
                                        <FormInput label="Código Estabelecimento" name="codigoEstabelecimento" span={2} disabled={true} />
                                        <FormInput label="Emitente Código" name="codigoEmitente" span={2} disabled={true} />
                                        <FormInput label="Emitente nome abreviado" name="nomeAbrevidoEmitente" span={2} disabled={true} />
                                        <FormInput label="Número do Contrato" name="numeroContrato" span={2} disabled={true} />
                                        <FormInput label="Data Início Contrato" name="dataInicioContrato" span={2} disabled={true} />
                                        <FormInput label="Data Fim Contrato" name="dataFimContrato" span={2} disabled={true} />
                                        <FormInput label="Número do Aditivo" name="numeroAditivo" span={2} disabled={true} />
                                        <FormInput label="Data de Confirmação do Aditivo" name="dataConfirmacaoAditivo" span={2} disabled={true} />
                                        <FormInput label="Hora de Confirmação do Aditivo" name="dataAtualizacaoAditivo" span={2} disabled={true} />
                                        <FormTextArea label="Narrativa" name="narrativa" rows={4} span={12} disabled={true} />
                                    </Widget>

                                    <PerfectScrollbar>
                                        <InlineEditTable
                                            columns={colum()}
                                            dataSource={bmTotv.tabelaAditivoTotvs}
                                            key={'id'}
                                            updateItem={(values: TabelaAditivo) => {
                                                let form = new FormData();
                                                form.append('id', values.id);
                                                form.append('pqId', values.pqId);

                                                if (values.saldo) {
                                                    form.append('saldo', values.saldo.toString());
                                                } else {
                                                    form.append('saldo', '');
                                                }
                                                if (itemValorAnteriorFormatado) {
                                                    form.append('itemValorAnteriorFormatado', itemValorAnteriorFormatado);
                                                } else {
                                                    form.append('itemValorAnteriorFormatado', '');
                                                }

                                                return updateTabelaContrato(bmTotv.id, form).then((data) => {
                                                    setItemValorAnteriorFormatado('');
                                                    setAtualizarTabela(!atualizarTabela);
                                                    return data;
                                                });
                                            }}
                                            pagination={false}
                                            disablenotification={false}
                                        />
                                    </PerfectScrollbar>
                                </MasterDetailForm>
                            </Panel>
                        </Collapse>
                    )
                })
            ) : (
                <></>
            )
            }
        </>
    );
}
export default BmTotvs


